import {handicaddieAsyncThunk} from "../../asyncThunk";
import {ClubService, GetClubsResponse} from "../../../api/ClubService";

export const loadClubs = handicaddieAsyncThunk(
    "Clubs/loadClubs",
    async (_, thunkAPI) => {
        let state = thunkAPI.getState();
        let userId = state.session.user?.id
        if ((state.clubs.allClubs && state.clubs.allClubs.length > 0) || !userId) {
            thunkAPI.abort()
            return {}
        }

        let allClubs: GetClubsResponse = await ClubService().getClubs()

        return {
            clubs: allClubs.clubs
        }
    }
);

